<template>
  <JobsListComponent/>
</template>

<script>

import JobsListComponent from '@/components/JobListComponent'

export default {
  name: 'Jobs',
  components: {JobsListComponent
  }
}
</script>